import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdCommunicationService {
  // Observable string sources
  private idAnnouncedSource = new Subject<string>();
  private idConfirmedSource = new Subject<string>();

  // Observable string streams
  idAnnounced$ = this.idAnnouncedSource.asObservable();
  idConfirmed$ = this.idConfirmedSource.asObservable();

  // Service message commands
  announceId(id: string) {
    this.idAnnouncedSource.next(id);
  }

  confirmMission(id: string) {
    this.idConfirmedSource.next(id);
  }
}
